import React from 'react';
import { Heart, Baby, Bone, Sparkles, Stethoscope, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';

const Specialties = () => {
  const specialties = [
    {
      icon: Heart,
      title: 'Infertility Treatment',
      description: 'Comprehensive fertility solutions with personalized care',
      services: [
        'Fertility assessment and counseling',
        'Hormonal therapy',
        'IUI procedures',
        'Ovulation monitoring',
        'Male infertility treatment',
      ],
      color: 'text-pink-500',
      bgColor: 'bg-pink-50',
    },
    {
      icon: Baby,
      title: 'Pregnancy Care',
      description: 'Complete antenatal and postnatal care for mother and baby',
      services: [
        'Regular pregnancy checkups',
        'Ultrasound scans (2D, 3D, 4D)',
        'Nutritional counseling',
        'High-risk pregnancy management',
        'Postnatal care and lactation support',
      ],
      color: 'text-purple-500',
      bgColor: 'bg-purple-50',
    },
    {
      icon: Bone,
      title: 'Orthopedics',
      description: 'Expert care for bone, joint, and muscle conditions',
      services: [
        'Fracture treatment',
        'Joint pain management',
        'Sports injury care',
        'Arthritis treatment',
        'Physiotherapy services',
      ],
      color: 'text-orange-500',
      bgColor: 'bg-orange-50',
    },
    {
      icon: Sparkles,
      title: 'Dermatology',
      description: 'Advanced skin care and cosmetic dermatology services',
      services: [
        'Skin disease treatment',
        'Acne and pigmentation care',
        'Hair loss treatment',
        'Cosmetic procedures',
        'Allergy testing',
      ],
      color: 'text-yellow-500',
      bgColor: 'bg-yellow-50',
    },
    {
      icon: Stethoscope,
      title: 'General Medicine',
      description: 'Comprehensive primary healthcare for all ages',
      services: [
        'Fever and infection treatment',
        'Chronic disease management',
        'Preventive health checkups',
        'Lifestyle disease management',
        'Vaccination services',
      ],
      color: 'text-blue-500',
      bgColor: 'bg-blue-50',
    },
    {
      icon: Users,
      title: 'Pediatrics',
      description: 'Expert child healthcare from infancy to adolescence',
      services: [
        'Well-baby checkups',
        'Childhood vaccinations',
        'Growth and development monitoring',
        'Pediatric emergencies',
        'Nutritional guidance',
      ],
      color: 'text-green-500',
      bgColor: 'bg-green-50',
    },
  ];

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <section className="bg-gradient-to-r from-[#0A2540] to-[#0EA5E9] py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1
            className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-4 tracking-tight"
            style={{ fontFamily: 'Outfit, sans-serif' }}
            data-testid="specialties-heading"
          >
            Medical Specialties
          </h1>
          <p className="text-xl text-white/90">Expert care across multiple medical disciplines</p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {specialties.map((specialty) => {
              const Icon = specialty.icon;
              return (
                <div
                  key={specialty.title}
                  className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all hover:-translate-y-1"
                  data-testid={`specialty-detail-${specialty.title.toLowerCase().replace(/\s+/g, '-')}`}
                >
                  <div className={`${specialty.bgColor} rounded-full w-16 h-16 flex items-center justify-center mb-4`}>
                    <Icon className={`h-8 w-8 ${specialty.color}`} />
                  </div>
                  <h3
                    className="text-2xl font-bold text-[#0A2540] mb-3"
                    style={{ fontFamily: 'Outfit, sans-serif' }}
                  >
                    {specialty.title}
                  </h3>
                  <p className="text-[#475569] mb-4">{specialty.description}</p>
                  <ul className="space-y-2">
                    {specialty.services.map((service) => (
                      <li key={service} className="flex items-start text-sm text-[#475569]">
                        <span className="text-[#0EA5E9] mr-2 flex-shrink-0">•</span>
                        {service}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>

          <div className="mt-12 bg-white rounded-2xl p-8 shadow-lg text-center">
            <h2
              className="text-3xl font-bold text-[#0A2540] mb-4"
              style={{ fontFamily: 'Outfit, sans-serif' }}
            >
              Need a Specialist Consultation?
            </h2>
            <p className="text-[#475569] mb-6 max-w-2xl mx-auto">
              Our team of experienced specialists is here to provide you with the best possible care. Book an appointment today.
            </p>
            <Link to="/contact" data-testid="book-specialist-appointment-button">
              <Button className="bg-[#0A2540] text-white hover:bg-[#0A2540]/90 rounded-full px-8 py-3">
                Book Appointment
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Specialties;